import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import Service from './Service'

export const postPeerAnalysisSearch = createAsyncThunk(
  'companyAnalysis/peerAnalysis/search',
  async (params, { rejectWithValue }) => {
    try {
      const res = await Service.postPeerAnalysisSearch(params)

      return res.success ? res.data : rejectWithValue({ isLoading: false })
    } catch (error) {
      rejectWithValue({ isLoading: axios.isCancel(error) })
    }
  },
)
